export enum ProfilesEnum {
  DIRETOR = 'Diretor',
  COORDENADOR = 'Coordenador',
  ALUNO = 'Aluno',
  PROFESSOR = 'Professor',
  RESP_FINANCEIRO = 'Responsável financeiro',
  RESP_PADAGOGICO = 'Responsável pedagógico',
  RESP_FINANCEIRO_PEDAGOGICO = 'Responsável financeiro e pedagógico',
  FUNCIONARIO = 'Funcionário',
  ASSESSOR = 'Assessor',
  ADMIN = 'Admin',
  SUPORTE = 'Suporte',
}
